export default __webpack_public_path__ + "static/media/sixth.c34d6fe7.jpg";